import React, { Component } from 'react';
import { Modal } from 'antd';
import { observer, inject } from 'mobx-react';

@inject('appStrategyStore')
@observer
class AccrossVersionsModal extends Component {
  constructor(props) {
    super(props);
    this.okFunc = this.okFunc.bind(this);
  }
  okFunc() {
    const {
      AddAppStrategy,
      AcrossVersionsDate,
      hideAcrossVersionsModal,
      hideAddStrategyModal
    } = this.props.appStrategyStore;
    AddAppStrategy(AcrossVersionsDate);
    window.location.reload();
    hideAcrossVersionsModal();
    hideAddStrategyModal();
  }
  render() {
    const {
      AcrossVersions,
      hideAcrossVersionsModal
    } = this.props.appStrategyStore;
    return (
      <div>
        <Modal
          visible={AcrossVersions}
          onOk={this.okFunc}
          onCancel={hideAcrossVersionsModal}
          width={'50%'}
        >
          当前操作存在跨版本升级情况，您确定这样进行么?
        </Modal>
      </div>
    );
  }
}

export default AccrossVersionsModal;



// WEBPACK FOOTER //
// ./src/components/AppStrategy/AcrossVersionsModal.js